import React from 'react'
import { Text, Textarea } from 'react-form'
import {Form, Col, FormGroup, Button} from 'react-bootstrap'
import ProgressBar from '../Common/ProgressBar/ProgressBar'

export default ({submitForm, message, isLoading, isAuthenticated}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}

      {!isAuthenticated && <FormGroup>
        <Col md={8} mdOffset={2} sm={4} smOffset={4} xs={8} xsOffset={2}>
          <Text
            field="phone"
            type="phone"
            placeholder="شماره موبایل"
            className="form-control"
          />
        </Col>
      </FormGroup>}

      <FormGroup>
        <Col md={8} mdOffset={2} sm={4} smOffset={4} xs={8} xsOffset={2}>
          <Textarea
            field="address"
            placeholder="آدرس"
            className="form-control"
            />
        </Col>
      </FormGroup>

      <FormGroup>
        <Col md={8} mdOffset={2} sm={4} smOffset={4} xs={8} xsOffset={2}>
          <Button type="submit" className="btnBlock" bsStyle="success">
            پرداخت و ارسال
          </Button>
          <ProgressBar isLoading={isLoading} type="button" />
        </Col>
      </FormGroup>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/Donate/PaymentDonateForm.js